export default function AttachFindingReportController(
  $rootScope,
  $scope,
  $q,
  $filter,
  $timeout,
  ssDialogService,
  loaderService,
  alerts,
  userService,
  amDataService
) {
  const vm = this;

  // Set Default Values
  vm.canExpand = vm.status !== 'No Report Added';
  vm.isExpanded = false;
  vm.loading = false;
  vm.permissions = null;

  // Attach Event Handlers
  vm.handleAttachReport = _handleAttachReport;
  vm.handleDownloadReport = _handleDownloadReport;

  _activate();

  // //////// METHODS //////////

  function _activate() {
    userService.getUserPermissionSet('auditTrail')
      .then((permissions) => {
        vm.permissions = permissions;
      });
  }

  function _handleAttachReport() {
    const dfdSave = $q.defer();
    loaderService.showViewLoader = true;

    if (vm.report.attached) {
      amDataService.attachFindingReport(vm.findingId, vm.report.reportInstanceId)
        .then((response) => {
          if (!response.data.findingReportInstanceId) {
            alerts.error('Error occurred while attaching the Report.');
            loaderService.showViewLoader = false;
            dfdSave.reject();
          } else {
            alerts.success(`Report ${vm.report.reportName} has been attached successfully.`);
            vm.report.findingReportInstanceId = response.data.findingReportInstanceId;
            $rootScope.$broadcast('refreshAMFindingReports', { findingId: vm.findingId });
            loaderService.showViewLoader = false;
            dfdSave.resolve();
          }
        });
    } else {
      amDataService.detachFindingReport(vm.report.findingReportInstanceId)
        .then(() => {
          alerts.success(`Report ${vm.report.reportName} has been detached successfully.`);
          vm.report.findingReportId = null;
          $rootScope.$broadcast('refreshAMFindingReports', { findingId: vm.findingId });
          dfdSave.resolve();
        })
        .catch(() => {
          alerts.error('Error occurred while detaching the Report.');
          dfdSave.reject();
        })
        .finally(() => {
          loaderService.showViewLoader = false;
        });
    }
  }

  function _handleDownloadReport() {
    /*
    var $ifrmDownloadFile = angular.element('#ifrmDownloadFile');
    var $frmDownloadFile = angular.element(
    '<form id="frmDownloadFile" method="get" target="ifrmDownloadFile"></form>'
    ).appendTo($ifrmDownloadFile);
    $frmDownloadFile.attr('action', paths.handlerDirectory + 'AM/LargeFileHandler.ashx');
    $frmDownloadFile.append('<input type="hidden" name="auditPackageId" value="' + vm.auditPackageId + '" />');
    $frmDownloadFile.submit();
    */
  }
}

AttachFindingReportController.$inject = [
  '$rootScope',
  '$scope',
  '$q',
  '$filter',
  '$timeout',
  'ssDialogService',
  'loaderService',
  'alerts',
  'userService',
  'amDataService',
];
